export default __webpack_public_path__ + "imgs/logo-wisart.png";